// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { JenisDokumenUpdateResponse } from "./types";

import * as jenisDokumenActions from "./jenisDokumen.actions";
import { showModal } from "../modal/modal.actions";

export function* updateJenisDokumen(
  action: ReturnType<typeof jenisDokumenActions.updateJenisDokumenAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `jenis-dokumen/${action.payload.DOK_JENIS_ID}`;
    const result: Response = yield call(apiPut, url, token, action.payload);

    if (result.status === 200) {
      const parsed: JenisDokumenUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(jenisDokumenActions.updateJenisDokumenAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.updateJenisDokumenAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisDokumenActions.updateJenisDokumenAsync.failure(parsed));
  }
}

export default function* jenisDokumenSagaUpdateJenisDokumen() {
  yield takeEvery(jenisDokumenActions.updateJenisDokumenAsync.request, updateJenisDokumen);
}
